import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    name: "BE_HOME",
    path: "/",
    alias: ["/benefit-estimator", "/benefit-estimator/"],

    component: () => import("@benefit-estimator/views/BenefitEstimatorV2.vue"),
    props: {
      page: "main",
    },
    meta: {
      title: "Benefit Estimator",
    },
  },
  {
    name: "BE_SCENARIOS",
    path: "/scenarios",
    alias: [
      "/scenarios",
      "/benefit-estimator/scenarios",
      "/benefit-estimator/scenarios/",
    ],
    component: () =>
      import("@benefit-estimator/views/BenefitEstimatorV2_Scenarios.vue"),
    props: {
      page: "scenarios",
    },
    meta: {
      title: "Benefit Estimator",
    },
  },

  {
    name: "BE_PLANS",
    path: "/scenarios/:id",
    alias: [
      "/scenarios/:id/",
      "/benefit-estimator/scenarios/:id",
      "/benefit-estimator/scenarios/:id/",
    ],
    component: () =>
      import("@benefit-estimator/views/BenefitEstimatorV2_Plans.vue"),
    props: {
      page: "plans",
    },
    meta: {
      title: "Benefit Estimator",
    },
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export default router;
